<template>
<div v-loading="loading" class="screen-container flex-column flex-auto">
  <div v-if="myData" class="flex-column flex-auto">
    <div class="page-sub-title margin-top-20">天然气进口关键指标</div>
    <div class="flex-column flex-auto padding-top-20 padding-lr-20">
      <el-row :gutter="20" type="flex" class="flex-auto">
        <el-col :span="8">
          <div class="myColumn flex-column">
            <div class="angle angle-lt"></div>
            <div class="angle angle-rt"></div>
            <div class="angle angle-lb"></div>
            <div class="angle angle-rb"></div>
            <div class="column-con flex-column flex-auto">
              <div>
                <div class="flex-row align-items-center justify-between">
                    <div class="column-title">TTF价格 / 亨利港价格</div>
                </div>
              </div>

              <Chart :option="trqjkgjzbChart" :legendAutoHeight="true" class="flex-auto"></Chart>
             
              <div class="flex-row padding-tb-10 margin-top-10 bold text-align-center">
                <div class="padding-lr-10" style="flex:1">日期</div>
                <div class="padding-lr-10" style="flex:1">单位</div>
                <div class="padding-lr-10" style="flex:1">TTF价格</div>
                <div class="padding-lr-10" style="flex:1">亨利港价格</div>
              </div>
              <div ref="div_1" @mouseover="tableScroll.tableMouseOver_1=1" @mouseout="tableScroll.tableMouseOver_1=0" style="height:0;flex:auto;overflow:hidden; border-radius: 5px;">
                <el-table
                  :data="myData['天然气进口关键指标']"
                  :show-header="false"
                  style="width: 100%">
                  <el-table-column
                    prop="日期"
                    align="center"
                  >
                  </el-table-column>
                  <el-table-column
                    align="center"
                  >
                  <template>美元/百万英热</template>
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="TTF价格"
                  ></el-table-column>
                  <el-table-column
                    align="center"
                    prop="亨利港价格"
                  ></el-table-column>
                </el-table>
              </div>

            </div>
          </div>
          
        </el-col>
        <el-col :span="8">
          <div class="myColumn flex-column">
            <div class="angle angle-lt"></div>
            <div class="angle angle-rt"></div>
            <div class="angle angle-lb"></div>
            <div class="angle angle-rb"></div>
            <div class="column-con flex-column flex-auto">
              <div>
                <div class="flex-row align-items-center justify-between">
                    <div class="column-title">LNG综合到岸价</div>
                </div>
              </div>

              <Chart :option="lngzhdajChart" :legendAutoHeight="true" class="flex-auto"></Chart>
             
              <div class="flex-row padding-tb-10 margin-top-10 bold text-align-center">
                <div class="padding-lr-10" style="flex:1">日期</div>
                <div class="padding-lr-10" style="flex:0 0 100px">单位</div>
                <div class="padding-lr-10" style="flex:1">LNG综合到岸价</div>
              </div>
              <div ref="div_2" @mouseover="tableScroll.tableMouseOver_2=1" @mouseout="tableScroll.tableMouseOver_2=0" style="height:0;flex:auto;overflow:hidden; border-radius: 5px;">
                <el-table
                  :data="myData['LNG综合到岸价']"
                  :show-header="false"
                  style="width: 100%">
                  <el-table-column
                    prop="日期"
                    align="center"
                  >
                  <template slot-scope="props">
                    {{ props.row['日期1'] }} 至 {{ props.row['日期2'] }}
                  </template>
                  </el-table-column>
                  <el-table-column
                    prop="单位"
                    width="100"
                    align="center"
                  >
                  <template>元/吨</template>
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="LNG综合到岸价"
                  ></el-table-column>
                </el-table>
              </div>

            </div>
          </div>
          
        </el-col>
        <el-col :span="8">
          <div class="myColumn flex-column">
            <div class="angle angle-lt"></div>
            <div class="angle angle-rt"></div>
            <div class="angle angle-lb"></div>
            <div class="angle angle-rb"></div>
            <div class="column-con flex-column flex-auto">
              <div>
                <div class="flex-row align-items-center justify-between">
                    <div class="column-title">接收站周度库容率</div>
                    <div v-if="myData['接收站周度库容率']&&myData['接收站周度库容率'].length" class="color-sub">统计周期：{{ myData['接收站周度库容率'][myData['接收站周度库容率'].length-1]['日期'] }}</div>
                </div>
              </div>

              <Chart :option="jszzdkrlChart" :legendAutoHeight="true" class="flex-auto"></Chart>
             
              <div class="flex-row padding-tb-10 margin-top-10 bold text-align-center">
                <div class="padding-lr-10" style="flex:1">日期</div>
                <div class="padding-lr-10" style="flex:1">接收站</div>
                <div class="padding-lr-10" style="flex:1">库容率</div>
              </div>
              <div ref="div_3" @mouseover="tableScroll.tableMouseOver_3=1" @mouseout="tableScroll.tableMouseOver_3=0" style="height:0;flex:auto;overflow:hidden; border-radius: 5px;">
                <el-table
                  :data="Object.keys(myData['接收站周度库容率'][0]).filter(v=>v!='日期')"
                  :show-header="false"
                  style="width: 100%">
                  <el-table-column
                    align="center"
                  >
                    <template>
                      {{ myData['接收站周度库容率'][myData['接收站周度库容率'].length-1]['日期'] }}
                    </template>
                    </el-table-column>
                  <el-table-column
                    align="center"
                  >
                    <template slot-scope="props">
                      {{ props.row }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    align="center"
                  >
                    <template slot-scope="props">
                      {{ myData['接收站周度库容率'][myData['接收站周度库容率'].length-1][props.row] }}
                    </template>
                  </el-table-column>
                </el-table>
              </div>

            </div>
          </div>
          
        </el-col>
      </el-row>

    </div>
  </div>
</div>
</template>

<script>
import Chart from "@/components/Chart";
import '@/common/china.js'//注册echarts中国地图
import XLSX from 'xlsx';
export default {
  name: 'Home',
  components:{
    Chart,
  },
  data(){
    return {
      loading:false,
      myData:null,
      tableScroll:{
         tableMouseOver_1:0,
         tableMouseOver_2:0,
         tableMouseOver_3:0,
      }
       

    }
  },
  computed:{
    trqjkgjzbChart(){
      if(this.myData['天然气进口关键指标']&&this.myData['天然气进口关键指标'].length){
        let chartData=this.myData['天然气进口关键指标']
        let opt =JSON.parse(JSON.stringify(this.$defaultChartOption)) 
        opt.grid.right=40
        for(let key in chartData[0]){
          if(key!='日期'){
            opt.legend.data.push(key)
          }
        }
        opt.xAxis.boundaryGap = true
        opt.xAxis.data=chartData.map(v=>{return v['日期']})
        opt.xAxis.axisLabel={
          showMinLabel:true,
          showMaxLabel:true,
          rotate:-45,
        }
        opt.yAxis.name='美元/百万英热'
        opt.series=opt.legend.data.map(v=>{
          return {
              name:v,
              data:  chartData.map(vv=>{return vv[v]}),
              type: 'line',
              endLabel:{
                show:true,
                fontWeight:'bold',
              },         
              labelLayout:{ moveOverlap:'shiftY'},
          }
        })
        opt.tooltip={
          trigger:'axis',
          formatter: (params)=>{
            var str=`<div>${params[0].axisValue}</div>`
            params.forEach((val)=>{
                str+=`<div>${val.marker}${val.seriesName}：${this.$numFormat(val.data,2,'-')} 美元/百万英热</div>`
            })
            return str
          },
        }
        return opt
      }else{
        return null
      }
      
    },
    lngzhdajChart(){
      if(this.myData['LNG综合到岸价']&&this.myData['LNG综合到岸价'].length){
        let chartData=this.myData['LNG综合到岸价']
        let opt =JSON.parse(JSON.stringify(this.$defaultChartOption)) 
        opt.grid.right=55
        opt.xAxis.boundaryGap = true
        opt.xAxis.data=chartData.map(v=>{return v['日期2']})
        opt.xAxis.axisLabel={
          showMinLabel:true,
          showMaxLabel:true,
          rotate:-45,
        }
        opt.yAxis.name='元/吨'
        opt.series=[
          {
              name:'LNG综合到岸价',
              data:  chartData.map(v=>{return v['LNG综合到岸价']}),
              type: 'line',
              color:this.$defaultChartOption.color[2],
              endLabel:{
                show:true,
                fontWeight:'bold',
              },         
              labelLayout:{ moveOverlap:'shiftY'},
          }
        ]
        opt.tooltip={
          trigger:'axis',
          formatter: (params)=>{
            var str=`<div>${params[0].axisValue}</div>`
            params.forEach((val)=>{
                str+=`<div>${val.marker}${val.seriesName}：${this.$numFormat(val.data,2,'-')} 元/吨</div>`
            })
            return str
          },
        }
        return opt
      }else{
        return null
      }
      
    },
    jszzdkrlChart(){
      if(this.myData['接收站周度库容率']&&this.myData['接收站周度库容率'].length){
        let chartData=this.myData['接收站周度库容率']
        let opt =JSON.parse(JSON.stringify(this.$defaultChartOption)) 
        opt.grid.right=55
        opt.xAxis.data=[]
        for(let key in chartData[0]){
          if(key!='日期'){
            opt.xAxis.data.push(key)
          }
        }
        opt.xAxis.boundaryGap = true
        opt.xAxis.axisLabel={
          showMinLabel:true,
          showMaxLabel:true,
          rotate:-45,
        }
        opt.yAxis.max=100
        opt.yAxis.scale=false
        opt.yAxis.axisLabel.formatter='{value}%'
        opt.series=[{
              name:'接收站周度库容率',
              data:  opt.xAxis.data.map(v=>{return parseFloat(chartData[chartData.length-1][v])}),
              type: 'bar',
              barGap: '50%',
              colorBy:'data',
              label:{
                show:true,
                position: 'top',
                formatter: '{c}%'
              }
          }
        ]
        opt.tooltip={
          trigger:'axis',
          formatter: (params)=>{
            var str=`<div>${params[0].axisValue}</div>`
            params.forEach((val)=>{
                str+=`<div>${val.marker}${val.seriesName}：${this.$numFormat(val.data,2,'-')} %</div>`
            })
            return str
          },
        }
        return opt
      }else{
        return null
      }
      
    },


  },
  created(){
    this.getData()
  },
  methods:{
    scroll(element,step){
       let obj=this.$refs[element]
       obj.scrollHeight>obj.clientHeight&&(obj.innerHTML+=obj.innerHTML);
       let fun=()=>{
        if(obj.scrollTop%step||!this.tableScroll[`tableMouseOver_${element.split('_')[1]}`]){
            obj.scrollTop++
            obj.scrollTop%=obj.scrollHeight>>1
          }
        setTimeout(fun,obj.scrollTop%step?10:3000)
       }
       fun()
    },
    getData(){
      this.loading=true
      this.$instance.get('/data/lng/LNG_DATA.xlsx',{
        baseURL:window.location.href.split('#')[0],
        responseType:'arraybuffer',
        headers: {
          'Content-Type': 'application/vnd.ms-excel', // 或 application/vnd.openxmlformats-officedocument.spreadsheetml.sheet
        },
      })
      .then(res=>{
        this.$message.closeAll()
        this.loading=false
        let data = new Uint8Array(res.data)
        let wb = XLSX.read(data, {type:"array"})
        let sheets = wb.Sheets // 获取文档数据
        let myData={}
        for(let key in sheets){
          myData[key]=XLSX.utils.sheet_to_json(sheets[key],{raw:false})
        }
        this.myData=myData
        this.$nextTick(()=>{
          this.init()
        })
        console.log(myData)

      })
      .catch(()=> {
        this.loading=false
      }); 
    },
    init(){
      this.$nextTick(()=>{
        this.scroll('div_1',48)
        this.scroll('div_2',48)
        this.scroll('div_3',48)
      })
    }
  },
  mounted(){
   
  },
  watch: {
   
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

</style>
<style scoped lang="scss">
@import './assets/css/common.scss';
</style>
